<template>
    <!-- 填空题 -->
    <div id="paper">
        <div class="choose">
            <p class="title_t"
               v-if="!!checked">
                <span v-if="ask_length>1"
                      :class="{num:!myColor}">({{question.number}})</span>
                <span v-if="question.subject.content.length"
                      :class="[myColor?'inspect_myColor':'title_p']"
                      v-html="$options.filters.strReplace(question.subject.content,'\#\#','或')"></span>
                <img :src="question.subject.image"
                     v-if="question.subject.image" />
            </p>
            <p class="title_t"
               v-else>
                <span v-if="ask_length>1"
                      class="num">({{question.number}})</span>
                <span v-if="question.subject.content.length"
                      :class="{'title_p':ask_length>1}"
                      v-html="$options.filters.strReplace(question.subject.content,'\#\#','或')"></span>
                <img :src="question.subject.image"
                     v-if="question.subject.image" />
            </p>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
export default {
    props: ['question', 'askLength', "checked", 'number', 'myColor'],
    data () {
        return {

        }
    },
    components: {

    },
    computed: {
        ask_length () {
            return this.askLength ? this.askLength : 1
        },
    },
    beforeRouteLeave (to, from, next) {

    },
    methods: {

    },
    created () {
        // //console.log(this.question.number)
        // this.$nextTick(function () {
        //   MathJax.Hub.Typeset(document.body);
        // })
    },
    destroyed () {

    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";
.title_t {
    background: $c-fbg;
    padding: $w;
    line-height: 48px / $ppr;
    border-bottom: $line 1px / $ppr solid;
    position: relative;
    word-break: break-all;
    .num {
        position: absolute;
        left: 25px / $ppr;
        top: 25px / $ppr;
        // background:#aaa;
    }
    .title_p {
        display: inline-block;
        padding-left: 50px / $ppr;
    }
}

.choose {
    background: $c-fbg;
    margin-top: $w;
    .p {
        padding: $w;
        line-height: 48px / $ppr;
        border-bottom: $line 1px / $ppr solid;
        min-height: 48px / $ppr;
    }

    .taskbottom {
        line-height: $h-header;
        height: $h-header;
        padding: 0 $w;
        font-size: $lt;
        color: $c-light;
        position: relative;
        span:nth-of-type(2) {
            line-height: 50px / $ppr;
            text-align: center;
            width: 120px / $ppr;
            height: 50px / $ppr;
            position: absolute;
            top: 20px / $ppr;
            right: 20px / $ppr;
            border-radius: 50px / $ppr;
            border: 1px / $ppr solid red;
            &.Select {
                color: #5e89ef;
                border: 1px / $ppr solid #5e89ef;
            }
            &.remove {
                color: #ff6600;
                border: 1px / $ppr solid #ff6600;
            }
        }
    }
}
</style>
